import React from "react";
import Charts from "./Charts";
import { Tabs, Tab } from "@nextui-org/react";
import CardGrid from "./CardGrid";

/**
 * EmissionInsight Component
 * Displays emission insights and analytics with tabbed interface
 * Shows emission data across different scopes and categories
 * @returns {JSX.Element} Emission insights dashboard with tabs
 */
const EmissionInsight = () => {
  return (
    <div className="my-8">
      {/* TODO: Future iframe integration for external emission insights */}
      {/* <iframe
        src="http://localhost:3000/emissions-insight/1/"
        // src={`${process.env.REACT_APP_EVIDENCE_DEV_IP_ADDRESS}/orgnization/${OrgInfo}`}
        title="description"
        style={{
          width: "70vw",
          height: "70vh",
          border: "none",
        }}
        className="hide-scrollbar"
      /> */}
      
      {/* TODO: Future chart integration */}
      {/* <Charts type="area" /> */}
      
      {/* Emission Insights Tabs */}
      <div className="h-full">
        <Tabs variant="underlined">
          {/* All Emissions Tab */}
          <Tab key="all-emissions" title="All emissions" className="h-full">
            <div className="h-full">
              <CardGrid />
            </div>
          </Tab>
          
          {/* TODO: Future scope-specific tabs for detailed emission analysis */}
          {/* <Tab key="scope-1" title="Scope 1">
            <CardGrid />
          </Tab>
          <Tab key="scope-2" title="Scope 2">
            <CardGrid />
          </Tab>
          <Tab key="scope-3" title="Scope 3">
            <CardGrid />
          </Tab> */}
        </Tabs>
      </div>
    </div>
  );
};

export default EmissionInsight;
